exports.linkResolver = (doc) => {
  // Backup for all other types
  return `/${doc.uid}/`;
};
